module.exports = __webpack_public_path__ + "img/PB063873.1ba9700a.jpg";